/**
 * @flow
 */

import React, { useContext, useRef, useLayoutEffect } from "react"
import _ from "lodash"
import { isBrowser } from "react-device-detect"
// import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import { ScrollerContext } from "./elements/SmoothScroll/context"

import d1 from "../images/drawings/1.png"
import d2 from "../images/drawings/2.png"
import d3 from "../images/drawings/3.png"
import d4 from "../images/drawings/4.png"
import d5 from "../images/drawings/5.png"
import d6 from "../images/drawings/6.png"
import d7 from "../images/drawings/7.png"
import d8 from "../images/drawings/8.png"
import d9 from "../images/drawings/9.png"
import d10 from "../images/drawings/10.png"
import d11 from "../images/drawings/11.png"
import d12 from "../images/drawings/12.png"
import d13 from "../images/drawings/13.png"
import d14 from "../images/drawings/14.png"
import d15 from "../images/drawings/15.png"
import d16 from "../images/drawings/16.png"
import d17 from "../images/drawings/17.png"
import d18 from "../images/drawings/18.png"

import Stoked from "./elements/Stoked"
// import Drawing from "./elements/Drawing"

import fb from "../images/social/social-fb.svg"
import insta from "../images/social/social-insta.svg"
import twt from "../images/social/social-twt.svg"
import drib from "../images/social/social-drib.svg"

import arrow from "../images/arrows/up.svg"

type Props = {}

const Container = styled.div`
  min-height: 100vh;
`

const Radness = styled.div`
  display: flex;
  /* justify-content: space-evenly; */
  justify-content: center;
  /* align-items: center; */
  align-items: baseline;
  flex-wrap: wrap;
  img {
    max-width: 75%;
    &.small {
      max-height: 75px;
      padding: var(--gutter-s);
    }
    &.med {
      max-height: 150px;
      padding: var(--gutter-s);
    }
    &.large {
      max-height: 300px;
      padding: var(--gutter-s);
    }
  }
  @media (min-width: 768px) {
    img {
      max-width: 100%;
      &.small {
        max-height: 100px;
        padding: var(--gutter-s);
      }
      &.med {
        max-height: 300px;
        padding: var(--gutter-m);
      }
      &.large {
        max-height: 600px;
        padding: var(--gutter-l);
      }
    }
  }
`

const Closing = styled.div`
  padding: var(--gutter-l) 0 var(--gutter-m);
  display: flex;
  justify-content: center;
  p {
    font-family: "AVALANCHE";
    text-align: center;
    max-width: 80vw;
    font-size: 1rem;
    line-height: 1.25rem;
    color: #29b2a0;
  }
  @media (min-width: 768px) {
    padding: var(--gutter-l) 0;
    p {
      max-width: 50vw;
      font-size: 1.35rem;
      line-height: 1.75rem;
    }
  }
`

const Peace = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto auto auto auto;
  grid-template-areas: "skater" "up" "social" "country" "copyright";
  padding: var(--gutter-s);
  .skater {
    align-self: center;
    justify-self: center;
    grid-area: skater;
    width: 300px;
    height: 300px;
    max-width: 100%;
    max-height: 100%;
    display: grid;
    grid-template: 1fr / 1fr;
    grid-template-areas: "skater";
    justify-items: center;
    align-items: center;
    img {
      grid-area: skater;
      max-width: 75%;
      position: relative;
    }
  }
  .up {
    grid-area: up;
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .country {
    grid-area: country;
    font-size: 0.8rem;
    display: flex;
    justify-content: center;
    padding: 0.5rem 0;
  }
  .social {
    grid-area: social;
    display: flex;
    justify-content: center;
    a {
      font-size: 0.8rem;
      padding: 0.25rem 0.25rem;
      margin: 0.25rem 0.25rem;
    }
  }
  .copyright {
    grid-area: copyright;
    font-size: 0.8rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    text-align: center;
    padding: 2rem 0 0.5rem;
  }
  @media (min-width: 768px) {
    grid-template-areas: "country skater social" ". copyright up";

    grid-template-columns: 75px 1fr 75px;
    grid-template-rows: 1fr 75px;
    .skater {
      width: 400px;
      height: 400px;
    }
    .up {
      padding: 0;
      justify-content: flex-end;
      align-items: flex-end;
    }
    .social {
      flex-direction: column;
      align-items: flex-end;
      a {
        writing-mode: vertical-rl;
        text-orientation: mixed;
        padding: 0.25rem 0;
        margin: 0.25rem 0;
      }
    }
    .country {
      writing-mode: vertical-rl;
      text-orientation: mixed;
      transform: scale(-1);
      padding: 0 0;
    }
    .copyright {
      padding: 0 0;
    }
  }
  @media (min-width: 1024px) {
    grid-template-columns: 100px 1fr 100px;
    grid-template-rows: 1fr 100px;
    .skater {
      width: 600px;
      height: 600px;
    }
  }
`

const StyledStoked = styled(Stoked)`
  grid-area: skater;
  width: 100%;
  height: 100%;
`

const Footer = ({ ...props }: Props) => {
  /*
  const data = useStaticQuery(graphql`
    query {
      d1: file(relativePath: { eq: "drawings/1.png" }) {
        childImageSharp {
          fluid(maxWidth: 220, maxHeight: 371, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `)
  */

  const context = useContext(ScrollerContext)

  const frameId = useRef(null)
  const containerEl = useRef(null)

  const onScroll = () => {
    let target = _.get(containerEl, "current").getBoundingClientRect().top
    let upperbound = window.innerHeight
    let lowerbound = _.get(containerEl, "current").getBoundingClientRect()
      .height
    const body = document.getElementsByTagName("BODY")[0]

    /* update background colour if month within active viewport */
    if (target < upperbound / 2 && target > 0 - lowerbound) {
      if (!body.classList.contains(`footer`)) {
        body.classList.add(`footer`)
      }
    } else {
      if (body.classList.contains(`footer`)) {
        body.classList.remove(`footer`)
      }
    }

    /* recall RAF whilst scrolling is still taking place */
    if (frameId.current && context.isScrolling) {
      frameId.current = window.requestAnimationFrame(onScroll)
    }
  }

  const scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }

  useLayoutEffect(() => {
    if (context.isScrolling) {
      frameId.current = window.requestAnimationFrame(onScroll)
    } else {
      window.cancelAnimationFrame(frameId.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.isScrolling])
  return (
    <Container ref={containerEl} {...props}>
      <Radness>
        <img className="med" src={d1} alt="2019" />
        <img className="med" src={d2} alt="2019" />
        <img className="small" src={d3} alt="2019" />
        <img className="large" src={d4} alt="2019" />
        <img className="med" src={d5} alt="2019" />
        <img className="small" src={d6} alt="2019" />
        <img className="large" src={d7} alt="2019" />
        <img className="small" src={d8} alt="2019" />
        <img className="med" src={d9} alt="2019" />
        <img className="small" src={d10} alt="2019" />
        <img className="small" src={d11} alt="2019" />
        <img className="med" src={d12} alt="2019" />
        <img className="med" src={d13} alt="2019" />
        <img className="small" src={d14} alt="2019" />
        <img className="med" src={d15} alt="2019" />
        <img className="small" src={d16} alt="2019" />
        <img className="med" src={d17} alt="2019" />
      </Radness>
      <Closing>
        <p>
          To all our partners, suppliers and the Geeks; thanks for a radical
          2019. It’s been crammed with go-lives, launches and laughter. Here’s
          to 2020 &#8213; a new year, a new decade, a new chance to make cool
          shit and make more memories.
        </p>
      </Closing>
      <Peace>
        <div className="country">Made in South Africa</div>
        <div className="skater">
          <StyledStoked />
          <img className="med" src={d18} alt="2019" />
        </div>
        <div className="social">
          <a
            href="https://www.instagram.com/teamgeek_/"
            target="_blank"
            rel="noopener noreferrer"
            className="mouse-link"
          >
            {isBrowser ? "Instagram" : <img src={insta} alt="Teamgeek 2019" />}
          </a>
          <a
            href="https://twitter.com/weareteamgeek"
            target="_blank"
            rel="noopener noreferrer"
            className="mouse-link"
          >
            {isBrowser ? "Twitter" : <img src={twt} alt="Teamgeek 2019" />}
          </a>
          <a
            href="https://www.facebook.com/weareteamgeek/?hc_ref=ARQMQAcZkcd0r-DQhaZ2HwdbrWA0Xxz7Txck65FIMw3t9QxqBBQBjDpF153ue834yjo&__xts__%5B0%5D=68.ARB1YTGMiVQesuxHT6NcsTpqgZ5JagkyBUKZqVHj-vK9s2LRbbzwdbX2r1XyQCzztbgu8kg0EULDRod37WuUu2_-hoKm2mZsVqSP2WSpyY80B4ZwzxNRQapx9XBd1dle08UAYdJWi9cJA1lf_za__fjMt7UhEgTv_mDyWJaXGp4YGhLqSo6qA3O-XVvsOBzpS4x84CN3VBC2UIQUpDo_ehCRgdpJpfTrX8Z9NL3I3GJquGmKBPAW6RatSfnepLE371EQzvBeWwOLuiU6jEp1pTGNhoD6GNLKAZNpPorCtU51ccLhrlALYntem-n4c4Nif-XoXCVjTwY4KyqPQw9Uk-lle113FQg0q3CP1HYAz6-ULk2H9kTqHJBh_braE8JBv8dYdduBZEJjiVcpRObZMofpVc-xPfxx-57DpCj95UE&__tn__=kC-R"
            target="_blank"
            rel="noopener noreferrer"
            className="mouse-link"
          >
            {isBrowser ? "Facebook" : <img src={fb} alt="Teamgeek 2019" />}
          </a>
          <a
            href="https://dribbble.com/teamgeek"
            target="_blank"
            rel="noopener noreferrer"
            className="mouse-link"
          >
            {isBrowser ? "Dribbble" : <img src={drib} alt="Teamgeek 2019" />}
          </a>
        </div>
        <div className="copyright">
          <p>&#169; Teamgeek 2020. All Rights Reserved.</p>
        </div>
        <div className="up">
          <img
            className="mouse-link"
            onClick={scrollTop}
            src={arrow}
            alt="Teamgeek 2019"
          />
        </div>
      </Peace>
    </Container>
  )
}

export default Footer
